module.exports = __webpack_public_path__ + "static/media/400400_02.3f72d0a9.png";